import moreInfo from './shared/moreInfo';
import trialInfo from './shared/trialInfo';
import { protocolClassNames } from '../classes'
import { setHiddenFields } from '../protocol/utils/utils';

const hideFields = {
  root: ["research_information"],
  participant_flow: {
    root: [
      "protocol_enrollment",
      "type_units_analyzed",
    ]
  }
}

export const eudraResultsUISchema = (configs) => {
  let preview = configs?.preview;
  let formData = configs?.formData;

  let returnObj = {
    "ui:options": {
      classNames: protocolClassNames
    },
    results: {
      "ui:order": ["trial_info", "participant_flow", "baseline_characteristics", "outcome_measures", "adverse_events", "*"],
      "ui:options": {
        classNames: {
          objectInnerContainer: "section-container",
        }
      },
      participant_flow: {
        "ui:options": {
          title: "Subject Disposition",
          classNames: {
            objectTitleContainer: "rjs-h1-container",
            objectTitle: "rjs-h1",
            fieldContainer: "rjs-full"
          }
        },
        recruitment_details: {
          "ui:options": {
            title: "Recruitment Details",
            label: false,
            charCountEnabled: true,
            maxChars: 350,
            classNames: {
              fieldContainer: "rjs-full",
            },
          },
          "ui:widget": "TextareaWidget"
        },
        pre_assignment_details: {
          "ui:options": {
            title: "Pre-assignment Details (Optional)",
            label: false,
            charCountEnabled: true,
            maxChars: 350,
            classNames: {
              fieldContainer: "rjs-full",
            },
          },
          "ui:widget": "TextareaWidget"
        },
        participant_flow_table: {
          "ui:options": {
            label: false,
            classNames: {
              fieldContainer: "rjs-full"
            }
          },
          "ui:widget": "ParticipantFlow"
        },
        ...setHiddenFields(hideFields.participant_flow.root)
      },
      baseline_characteristics: {
        "ui:options": {
          title: "Baseline Characteristics",
          classNames: {
            objectTitleContainer: "rjs-h1-container",
            objectTitle: "rjs-h1",
            fieldContainer: "rjs-full"
          }
        },
        baseline_characteristics_table: {
          "ui:options": {
            label: false,
          },
          "ui:widget": "BaselineCharacteristics"
        }
      },
      outcome_measures: {
        "ui:options": {
          title: "End Points",
          customFnProps: [
            {
              tooltip: "Copy all outcome measures from CTG Protocol",
              fnKey: "copy-ctg-protocol-om-to-results",
              fnArgs: {
                // type: "copy-ctg-om",
              }
            },
            {
              tooltip: "Sort by Outcome Measure/End Point Type",
              icon: "fa-light fa-sort",
              fnKey: "sort-result-oms-by-type",
              fnArgs: {
                // type: "copy-ctg-om",
              }
            }],
          classNames: {
            objectTitleContainer: "rjs-h1-container",
            objectTitle: "rjs-h1",
            fieldContainer: "rjs-full"
          }
        },
        outcome_measures_table: {
          "ui:options": {
            label: false,
          },
          "ui:widget": "OutcomeMeasures"
        }
      },
      adverse_events: {
        "ui:options": {
          title: "Adverse Events",
          classNames: {
            objectTitleContainer: "rjs-h1-container",
            objectTitle: "rjs-h1",
            fieldContainer: "rjs-full"
          }
        },
        adverse_events_table: {
          "ui:options": {
            label: false,
          },
          "ui:widget": "AdverseEvents"
        }
      },
      more_info: moreInfo("eudract", preview),
      trial_info: trialInfo("eudract", preview),
      ...setHiddenFields(hideFields.root)
    }
  }

  return returnObj;
}